import { defineElement } from '@umbraco-ui/uui-base/lib/registration';
import { slotHasContent, demandCustomElement } from '@umbraco-ui/uui-base/lib/utils';
import { UUICardElement } from '@umbraco-ui/uui-card/lib';
import { html, css, nothing } from 'lit';
import { property, state } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _UUICardUserElement_instances, renderButton_fn, renderLink_fn, renderContent_fn;
let UUICardUserElement = class extends UUICardElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _UUICardUserElement_instances);
    this.name = "";
    this._avatarSlotHasContent = false;
    this._avatarSlotChanged = (e) => {
      this._avatarSlotHasContent = slotHasContent(e.target);
    };
  }
  connectedCallback() {
    super.connectedCallback();
    demandCustomElement(this, "uui-avatar");
  }
  render() {
    return html`
      ${this.href ? __privateMethod(this, _UUICardUserElement_instances, renderLink_fn).call(this) : __privateMethod(this, _UUICardUserElement_instances, renderButton_fn).call(this)}
      <!-- Select border must be right after #open-part -->
      <div id="select-border"></div>
      <slot name="tag"></slot>
      <slot name="actions"></slot>
    `;
  }
};
_UUICardUserElement_instances = new WeakSet();
renderButton_fn = function() {
  return html`<div
      id="open-part"
      tabindex=${this.disabled ? nothing : "0"}
      @click=${this.handleOpenClick}
      @keydown=${this.handleOpenKeydown}>
      ${__privateMethod(this, _UUICardUserElement_instances, renderContent_fn).call(this)}
    </div>`;
};
renderLink_fn = function() {
  return html`<a
      id="open-part"
      tabindex=${this.disabled ? nothing : "0"}
      href=${ifDefined(!this.disabled ? this.href : void 0)}
      target=${ifDefined(this.target || void 0)}
      rel=${ifDefined(
    this.rel || ifDefined(
      this.target === "_blank" ? "noopener noreferrer" : void 0
    )
  )}>
      ${__privateMethod(this, _UUICardUserElement_instances, renderContent_fn).call(this)}
    </a>`;
};
renderContent_fn = function() {
  return html`<div id="content">
      ${this._avatarSlotHasContent ? nothing : html`<uui-avatar
            class="avatar"
            name=${this.name}
            size="m"></uui-avatar>`}
      <slot
        name="avatar"
        class="avatar"
        @slotchange=${this._avatarSlotChanged}></slot>
      <span title="${this.name}">${this.name}</span>
      <slot></slot>
    </div>`;
};
UUICardUserElement.styles = [
  ...UUICardElement.styles,
  css`
      :host {
        min-width: 250px;
      }

      slot:not([name])::slotted(*) {
        font-size: var(--uui-type-small-size,12px);
        line-height: var(--uui-size-6,18px);
      }

      ::slotted(*) {
        text-align: center;
      }

      slot[name='tag'] {
        position: absolute;
        top: 6px;
        right: 6px;
        display: flex;
        justify-content: right;
      }

      slot[name='actions'] {
        position: absolute;
        top: var(--uui-size-space-4,12px);
        right: var(--uui-size-space-4,12px);
        display: flex;
        justify-content: right;

        opacity: 0;
        transition: opacity 120ms;
      }
      :host(:focus) slot[name='actions'],
      :host(:focus-within) slot[name='actions'],
      :host(:hover) slot[name='actions'] {
        opacity: 1;
      }

      #open-part {
        cursor: pointer;
        flex-grow: 1;
        padding: var(--uui-size-space-5,18px) var(--uui-size-space-4,12px);
      }

      :host([disabled]) #open-part {
        pointer-events: none;
      }

      #open-part:hover #content {
        color: var(--uui-color-interactive-emphasis,#3544b1);
      }
      #open-part:hover #content > span {
        text-decoration: underline;
      }

      :host([selectable]) #open-part {
        padding: 0;
        margin: var(--uui-size-space-5,18px) var(--uui-size-space-4,12px);
      }

      #content {
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;
        margin: 0 0 3px 0;
        height: 100%;
      }

      #content > span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: center;
        margin-top: 3px;
        font-weight: 700;
        overflow-wrap: anywhere;
      }

      .avatar {
        font-size: 1.5em;
        margin-top: var(--uui-size-space-1,3px);
        margin-bottom: var(--uui-size-space-2,6px);
      }
    `
];
__decorateClass([
  property({ type: String })
], UUICardUserElement.prototype, "name", 2);
__decorateClass([
  state()
], UUICardUserElement.prototype, "_avatarSlotHasContent", 2);
UUICardUserElement = __decorateClass([
  defineElement("uui-card-user")
], UUICardUserElement);

export { UUICardUserElement };
